import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useEffect, useState } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

function useStudents() {
  const [students, setStudents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch('https://api.edicionesmilenio.com/api/students')
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        let st = data?.data?.map((student) => {
          return {
            _id: student?._id,
            name: student?.name || '',
            lastName: student?.lastName || '',
            grade: student?.grade?.name || '',
            course: student?.course
              ? `${student?.course?.numericName} (${student?.course?.alphaName})`
              : '',
            institution: student?.institution?.name || '',
          };
        });
        setStudents(st);
      });
  }, []);

  return { students, setStudents, isLoading };
}

export function Students() {
  const { students, setStudents, isLoading } = useStudents();
  const navigate = useNavigate();

  const routeChange = (id) => {
    navigate(`/admin/students-update/${id}`);
  };
  const classes = useStyles();

  const columns = [
    {
      name: 'name',
      label: 'Nombre',
      options: {
        filter: false,
      },
    },
    {
      name: 'lastName',
      label: 'Apellido',
      options: {
        filter: false,
      },
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'course',
      label: 'Curso',
    },
    {
      name: 'institution',
      label: 'Institución',
    },
    {
      name: 'actions',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <Button
              color="primary"
              onClick={() => routeChange(students[dataIndex]?._id)}
            >
              <FaEdit />
            </Button>
          );
        },
      },
    },
  ];

  const handleDelete = (rowsDeleted) => {
    const confirm = window.confirm(
      '¿Está seguro que desea eliminar los estudiantes seleccionados?'
    );
    if (confirm) {
      rowsDeleted.data.forEach(async (row) => {
        let response = await fetch(
          `https://api.edicionesmilenio.com/api/students/${
            students[row?.dataIndex]?._id
          }`,
          {
            method: 'DELETE',
          }
        );
        let data = await response.json();
      });
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        estudiantes autorizados por la editorial para cada institución
        educativa, recuerda que puedes usar las herramientas de buscar, filtrar,
        entre otras.
      </p>
      {!isLoading ? (
        <MUIDataTable
          title={'Listado de estudiantes'}
          data={students}
          columns={columns}
          options={{
            filterType: 'dropdown',
            onRowsDelete: (rowsDeleted) => {
              handleDelete(rowsDeleted);
            },
          }}
        />
      ) : (
        <CircularProgress color="primary" />
      )}
    </div>
  );
}
